import { NgModule } from '@angular/core';
import { asmTranslationChunksConfig } from "@spartacus/asm/assets";
import { ASM_FEATURE, AsmRootModule } from "@spartacus/asm/root";
import { CmsConfig, I18nConfig, provideConfig } from "@spartacus/core";
import { en } from "../../../../../public/translations/en";
import { es } from "../../../../../public/translations/es";
@NgModule({
  declarations: [],
  imports: [
    AsmRootModule
  ],
  providers: [provideConfig(<CmsConfig>{
    featureModules: {
      [ASM_FEATURE]: {
        module: () =>
          import('@spartacus/asm').then((m) => m.AsmModule),
      },
    }
  }),
  provideConfig(<I18nConfig>{
    i18n: {
      resources:
      {
        en: {asm: en.asm},
        es: {asm: es.asm},
      },
      chunks: asmTranslationChunksConfig,
    },
  })
  ]
})
export class AsmFeatureModule { }
